var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFolderIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.81 4.146c-.522-.424-.783-.637-1.075-.788a3.2 3.2 0 0 0-.82-.291C9.592 3 9.254 3 8.581 3H3.84c-1.344 0-2.016 0-2.53.262A2.4 2.4 0 0 0 .262 4.31C0 4.824 0 5.496 0 6.84v18.32c0 1.344 0 2.016.262 2.53a2.4 2.4 0 0 0 1.048 1.048C1.824 29 2.496 29 3.84 29h24.32c1.344 0 2.016 0 2.53-.262a2.4 2.4 0 0 0 1.048-1.048c.262-.514.262-1.186.262-2.53V10.09c0-1.344 0-2.016-.262-2.53a2.4 2.4 0 0 0-1.048-1.048c-.514-.262-1.186-.262-2.53-.262H16.218c-.674 0-1.01 0-1.332-.067a3.2 3.2 0 0 1-.82-.291c-.293-.151-.554-.364-1.077-.788z",
  fill: "#fedd69"
})));
export { SvgFolderIcon as ReactComponent };